(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.faq = {
    attach: function (context, settings) {
      $(once('hide', '.node--faq-item .node__content')).hide();

      $(once('faq-click', '.node--faq-item')).each(function(e){
        $(this).find('.node__header').click(function(e){
          e.preventDefault();
          $(this).parents('.node--faq-item').toggleClass('open').find('.node__content').slideToggle({
            progress: function() {
              Drupal.behaviors.overlapping_backgrounds.callPBackgroundsSize();
            }
          });
        });
      });
    }
  };


})(jQuery, Drupal);
